import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";

import { coursesCalendarRideStatusFilterAtom } from "@ryde/shared";

import { CoursesCalendarToolbarSelect } from "./courses-calendar-toolbar-select";
import {
  buildCoursesCalendarToolbarSelectOptions,
  COURSES_CALENDAR_RIDE_STATUS_FILTER_E2E,
  COURSES_CALENDAR_RIDE_STATUS_FILTER_LABEL_KEYS,
  COURSES_CALENDAR_RIDE_STATUS_FILTERS,
  COURSES_CALENDAR_TOOLBAR_SELECT_RIDES_CLASS,
  COURSES_CALENDAR_TOOLBAR_SELECT_RIDES_MIN_WIDTH,
} from "./parts";

export const CoursesRideStatusFilter: FC = () => {
  const { t } = useTranslation();
  const [value, setValue] = useRecoilState(coursesCalendarRideStatusFilterAtom);

  const options = useMemo(
    () =>
      buildCoursesCalendarToolbarSelectOptions(
        COURSES_CALENDAR_RIDE_STATUS_FILTERS,
        COURSES_CALENDAR_RIDE_STATUS_FILTER_LABEL_KEYS,
        t,
      ),
    [t],
  );

  return (
    <CoursesCalendarToolbarSelect
      value={value}
      allowedValues={COURSES_CALENDAR_RIDE_STATUS_FILTERS}
      options={options}
      onValueChange={setValue}
      className={COURSES_CALENDAR_TOOLBAR_SELECT_RIDES_CLASS}
      data-e2e={COURSES_CALENDAR_RIDE_STATUS_FILTER_E2E}
      minWidth={COURSES_CALENDAR_TOOLBAR_SELECT_RIDES_MIN_WIDTH}
    />
  );
};
